import * as utils from "@/components/util/utils";

const myModule: {
    [key: string]: any
} = {
    type: 'normal',
    name: 'message',
    version: 'PageNormal',
    api: {
        query: "/messageUser/query",
        queryByAll: "/messageUser/queryByAll",
        queryById: "/messageUser/queryById",
        save: "/messageUser/save",
        delete: "/factoryreport/delete",
        queryUser: "/messageUser/queryUser",
    },

    components: [{
            modelName: 'content',
            type: 'AssemblyQuery',
            components: [{
                modelName: 'query',
                type: 'AssemblyFrom',
                components: [{
                        modelName: 'content',
                        name: "no_str",
                        label: "通知类型",
                        type: 'ComponentsInput'
                    },
                    {
                        modelName: 'content',
                        type: 'ComponentsInputReQuery'
                    },
                ]
            }],
        },
        {
            modelName: 'content',
            type: 'AssemblyContent',
            title: "消息通知模板",
            components: [{
                    modelName: 'content',
                    name: "no_str",
                    label: "通知类型",
                    type: 'ComponentsInput'
                },
                {
                    modelName: 'content',
                    name: "main_str",
                    label: "主送通知",
                    type: 'ComponentsInput'
                },
                {
                    modelName: 'content',
                    name: "down_str",
                    label: "抄送通知",
                    type: 'ComponentsInput'
                },
                {
                    modelName: 'content',
                    name: "create_name",
                    label: "创建人",
                    type: 'ComponentsInput'
                },
                {
                    modelName: 'content',
                    name: "update_name",
                    label: "修改人",
                    type: 'ComponentsInput'
                }

            ],
            toolBtn: [],
            tableBtn: [{
                label: "编辑",
                jurisdictionJson: [{
                    jurisdiction: [{
                        name: "edit"
                    }]
                }],
                show: true,
                click: function (data: any) {
                    let edit = utils.getStore().openDialog({
                        name: 'edit',
                        title: "编辑"
                    })
                    edit.query()
                }
            }, ]
        },
        {
            modelName: 'dialog',
            name: "edit",
            type: 'DialogEdit',
            components: [{
                modelName: 'from',
                type: 'AssemblyFrom',
                components: [{
                        modelName: 'content',
                        name: "no_str",
                        label: "通知类型",
                        label_width: "150px",
                        type: 'ComponentsInputTextarea',
                        show_type: "详情"
                    },
                    {
                        modelName: 'content',
                        name: "main_str",
                        label: "主送人消息提示",
                        label_width: "150px",
                        type: 'ComponentsInputTextarea'
                    },
                    {
                        modelName: 'content',
                        name: "main_user",
                        label: "主送人",
                        label_width: "150px",
                        type: 'ComponentsInputSelectMultiple',
                        rules: [{
                            validator: utils.my_required,
                            message: "请选择主送人"
                        }],
                        ajax_url: "queryUser",
                        props_label: "ui_name",
                        props_value: "id",
                        style: "width:390px;"
                    },
                    {
                        modelName: 'content',
                        name: "down_str",
                        label: "抄送人消息提示",
                        label_width: "150px",
                        type: 'ComponentsInputTextarea'
                    },
                    {
                        modelName: 'content',
                        name: "down_user",
                        label: "抄送人",
                        label_width: "150px",
                        type: 'ComponentsInputSelectMultiple',
                        ajax_url: "queryUser",
                        props_label: "ui_name",
                        props_value: "id",
                        style: "width:390px;"
                    },
                    {
                        modelName: 'content',
                        name: "id",
                        label: "id",
                        type: 'ComponentsInputHidden'
                    },
                ]
            }]
        },
    ]
}
export default myModule